<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="scss">
@media screen and (min-width: 540px) {
  html {
    font-size: 54PX!important;
  }
}
</style>